import Checkbox from "@shared/v2/Checkbox";
import Flyout from "@shared/v2/Flyout";

import ListingDetails from "./ListingDetails";
import "../details.scss";

const ListingDetailsModal = ({
  listing,
  buyerMatches,
  isSelected,
  numberSelected,
  selectedLimit,
  onToggleShare,
  sendToLead,
  maxListingsSelected,
  setSharedListing,
  onClose,
  openAgentDetailsModal,
  agentDetailsEnabled,
}) => (
  <Flyout id="listing-details-modal" show onHide={onClose}>
    <div className="tw-flex tw-flex-col tw-h-full tw-overflow-hidden">
      <Flyout.Header>
        <Checkbox
          checked={isSelected}
          onChange={() => onToggleShare(listing)}
          disabled={maxListingsSelected && !isSelected}
          label={` ${numberSelected}/${selectedLimit} selected`}
        />
      </Flyout.Header>

      <Flyout.Body className="tw-flex-1 tw-overflow-auto tw-max-w-[760px]">
        <ListingDetails
          listing={listing}
          setSharedListing={setSharedListing}
          buyerMatches={buyerMatches}
          sendToLead={sendToLead}
          onShowAgentDetails={openAgentDetailsModal}
          agentDetailsEnabled={agentDetailsEnabled}
          onClose={onClose}
        />
      </Flyout.Body>
    </div>
  </Flyout>
);

export default ListingDetailsModal;
